export default "__VITE_ASSET__Bb0BNuKZ__$_?inline__"